import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DamagesService } from '../damages.service';
import {
  getIncidents,
  getIncidentsFailure,
  getIncidentsSuccess,
} from './recent-surveys.actions';
import { of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class RecentSurveysEffects {
  private readonly actions$ = inject(Actions);
  private readonly service = inject(DamagesService);

  public getIncidents$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getIncidents),
      switchMap(() =>
        this.service.getIncidents().pipe(
          map((incidents) => {
            return getIncidentsSuccess({ incidents });
          }),
          catchError((err) => of(getIncidentsFailure({ error: err })))
        )
      )
    )
  );
}
